import React, { useEffect } from "react";

import VideoPlayer from "../../components/Reusable/VideoPlayer";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const VideoEducation = () => {
  const navigate = useNavigate();
  const { educationItemsList, educationVideo } = useSelector(
    (state) => state.educationReducer
  );
  const src = educationVideo;

  const handlePlay = () => {
    // Pokreć funkciju za "onStart"
  };

  // Ako `educationItemsList` nije učitan, preusmeravamo korisnika
  useEffect(() => {
    if (!educationItemsList || !educationItemsList.lessons) {
      navigate("/education-list");
    }
  }, [educationItemsList, navigate]);

  // Provera da li `educationItemsList` ima validne podatke
  if (!educationItemsList || !educationItemsList.lessons) {
    return null;
  }

  const handleEnded = () => {
    if (educationItemsList?.lessons?.length > 0) {
      navigate("/lessons");
    } else {
      if (educationItemsList?.questions?.length > 0) {
        navigate("/questions");
      } else {
        navigate("/education-list");
      }
    }
  };

  return (
    <div className="video-education">
      <VideoPlayer src={src} onStart={handlePlay} onEnd={handleEnded} />
    </div>
  );
};

export default VideoEducation;
